import { Account, AccountType } from '@arrived/models';

export const isMissingEntityTitle = ({ type, entityTitle }: Account) =>
  type !== AccountType.INDIVIDUAL && entityTitle == null;
